import React from 'react';
import { MailIcon, MessageCircleIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full border-t border-ink-line bg-ink-soft px-5 py-10" data-id="element-93" data-mp="2082jj8gp4kfn">
      <div className="mx-auto max-w-4xl text-center" data-id="element-94" data-mp="2f4tk3l23w26u">
        <p className="font-display text-3xl leading-none text-lime" data-id="element-95" data-mp="2f4bgg3d46low">
          MegaPack Árabe <span className="text-gold" data-id="element-96" data-mp="2a6s4xb7swn0n">PRO</span>
        </p>
        <p className="mt-2 text-[10px] font-extrabold uppercase tracking-[0.28em] text-snow-dim" data-id="element-97" data-mp="1mg5x9l1pl4r6">
          Inspira · Enseña · Transforma
        </p>
        <p className="mt-3 text-sm font-semibold text-snow-muted" data-id="element-98" data-mp="1hie7oxojduq5">por Aula Baile Pro</p>

        <nav className="mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm font-semibold text-snow-muted" data-id="element-99" data-mp="1w70rpcp3zanp">
          <a href="#soporte" className="inline-flex items-center gap-1.5 transition-colors hover:text-lime" data-id="element-100" data-mp="1rdxvewsy5n3t">
            <MailIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-101" data-mp="13nk6hf5ns4dg" /> Soporte
          </a>
          <a href="#contacto" className="inline-flex items-center gap-1.5 transition-colors hover:text-lime" data-id="element-102" data-mp="yqbmra4v3sa3">
            <MessageCircleIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-103" data-mp="1eg9e2po5gtn1" /> Contacto
          </a>
          <a href="#terminos" className="transition-colors hover:text-lime" data-id="element-104" data-mp="1ihkxgdgfkims">
            Términos y condiciones
          </a>
        </nav>

        <p className="mx-auto mt-6 max-w-2xl text-xs leading-relaxed text-snow-dim" data-id="element-105" data-mp="1s9ql5azngdw6">
          Material digital de uso personal para profesoras de Danza Árabe. Los resultados dependen de la
          aplicación de cada profesora. © {new Date().getFullYear()} Aula Baile Pro.
        </p>
      </div>
    </footer>;
}